import React, { Fragment } from 'react';
import { shouldHideField } from 'Components/widgets/contact-info/ContactInfoUtils';
import { useAppContext } from 'Context/ReactAppContext';
import type { State as userInfoType } from 'Store/user-info/reducers/userInfoReducer';
import 'Store/user-info/reducers/userInfoReducer';
import type { ValidatorsType } from 'Components/widgets/contact-info/ContactInfoUtils';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
import { t } from 'Src/i18n';
import { BucketFormikInput as FormikInput } from 'Src/types/forms';
type Props = {
  attendeeIdentifier: string;
  connectedUserInfo?: userInfoType;
  onKeyDown?: (e: KeyboardEvent) => void;
  validators: ValidatorsType;
  isUnicodeFirstNameVisible: boolean;
  isUnicodeFirstNameRequired: boolean;
  isUnicodeLastNameVisible: boolean;
  isUnicodeLastNameRequired: boolean;
  hideErrorMessage?: boolean;
  isMain?: boolean;
  isChild?: boolean;
};
export const UnicodeFields = ({
  attendeeIdentifier,
  connectedUserInfo,
  onKeyDown,
  validators,
  isUnicodeFirstNameVisible,
  isUnicodeFirstNameRequired,
  isUnicodeLastNameVisible,
  isUnicodeLastNameRequired,
  hideErrorMessage,
  isMain,
  isChild,
}: Props) => {
  const appContext = useAppContext();
  const isLastnameFirst = isFeatureFlipped(appContext)('booking.lastnameFirst');
  const unicodeFirstNameInputs = (
    <FormikInput
      hideErrorMessage={hideErrorMessage}
      isDisabled={shouldHideField({
        connectedUserInfo,
        fieldName: 'unicodeFirstName',
        isMain,
        isChild,
      })}
      isRequired={isUnicodeFirstNameRequired}
      label={t('booking.participants.labels.unicodeFirstName')}
      name={`${attendeeIdentifier}.unicodeFirstName`}
      onKeyDown={onKeyDown}
      type="text"
      validate={validators.unicodeFirstName}
    />
  );
  const unicodeLastNameInputs = (
    <FormikInput
      hideErrorMessage={hideErrorMessage}
      isDisabled={shouldHideField({
        connectedUserInfo,
        fieldName: 'unicodeLastName',
        isMain,
        isChild,
      })}
      isRequired={isUnicodeLastNameRequired}
      label={t('booking.participants.labels.unicodeLastName')}
      name={`${attendeeIdentifier}.unicodeLastName`}
      onKeyDown={onKeyDown}
      type="text"
      validate={validators.unicodeLastName}
    />
  );
  return (
    <Fragment>
      {(isLastnameFirst ? isUnicodeLastNameVisible : isUnicodeFirstNameVisible) && (
        <div className="p-10 sm:w-1/2">
          {isLastnameFirst ? unicodeLastNameInputs : unicodeFirstNameInputs}
        </div>
      )}
      {(isLastnameFirst ? isUnicodeFirstNameVisible : isUnicodeLastNameVisible) && (
        <div className="p-10 sm:w-1/2">
          {isLastnameFirst ? unicodeFirstNameInputs : unicodeLastNameInputs}
        </div>
      )}
    </Fragment>
  );
};
